import { createAction, props } from '@ngrx/store';

export const loadProductUis = createAction(
  '[ProductUi] Load ProductUis'
);

export const setSelectedProduct = createAction (
  '[ProductUi] Set Selected Product',
  props<{
    skuId:number
  }>()
)

export const clearSelectedProduct = createAction (
  '[ProductUi] Clear Selected Product',
)

export const setSelectedProductCategory = createAction(
  '[ProductUI] Set Selected Product Category',
  props<{
    uiselectedProductcategory: string[]
  }>()
)


export const clearSelectedProductCategory = createAction(
  '[ProductUI] Clear Selected Product Category'
)

export const setSelectedProductSorting = createAction(
  '[ProductUI] Set Selected Product Sorting',
  props<{
    uiselectedProductSorting: string
  }>()
)

export const clearSelectedProductSorting = createAction(
  '[ProductUI] Clear Selected Product Sorting',
)

export const setSelectedProductBrand = createAction(
  '[ProductUI] Set Selected Product Brand',
  props<{
    uiselectedProductBrand: string[]
  }>()
)

export const clearSelectedProductBrand = createAction(
  '[ProductUI] Clear Selected Product Brand',
)

export const setSelectedProductOrigCountries = createAction(
  '[ProductUI] Set Selected Product Origin Countries',
  props<{
    uiselectedProductOrigCountries: string[]
  }>()
)

export const clearSelectedProductOrigCountries = createAction(
  '[ProductUI] Clear Selected Product Origin Countries',
)

export const setSelectedProductPriceRange = createAction(
  '[ProductUI] Set Selected Product Price Range',
  props<{
    uiselectedProductPriceRange: number[]
  }>()
)

export const clearSelectedProductPriceRange = createAction(
  '[ProductUI] Clear Selected Product Price Range',
)

export const clearProductUIFilter = createAction(
  '[ProductUI] ClearProduct UI Filter'
)

export const setGlobalSkuSearchKeyword = createAction(
  '[ProductUI] Set Global Sku Search Keyword',
  props<{
    globalKeyword:string
  }>()
)

export const setGlobalSearchKeywordForAutoComplete = createAction(
  '[ProductUI] Set Global Sku Search Keyword For Auto Complete',
  props<{
    uiglobalSearchKeywordForAutoComplete:string
  }>()
)

export const setAddNewSKUSearchKeywordForAutoComplete = createAction(
  '[ProductUI] Set Add New Sku Search Keyword For Auto Complete',
  props<{
    uiaddNewSKUSearchKeywordForAutoComplete:string
  }>()
)

export const clearAddNewSKUSearchKeywordForAutoComplete = createAction(
  '[ProductUI] Clear Add New Sku Search Keyword For Auto Complete',
)

export const setAddNewSKUSearchKeywordForAutoCompleteInShoppingCart = createAction(
  '[ProductUI] Set Add New Sku Search Keyword For Auto Complete In Shopping Cart',
  props<{
    uiaddNewSKUSearchKeywordForAutoCompleteInShoppingCart:string
  }>()
)

export const clearAddNewSKUSearchKeywordForAutoCompleteInShoppingCart = createAction(
  '[ProductUI] Clear Add New Sku Search Keyword For Auto Complete In Shopping Cart',
)

export const setAddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart = createAction(
  '[ProductUI] Set Add New Sku Search Keyword For Auto Complete In Bulk Shopping Cart',
  props<{
    uiaddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart:string
  }>()
)

export const clearAddNewSKUSearchKeywordForAutoCompleteInBulkShoppingCart = createAction(
  '[ProductUI] Clear Add New Sku Search Keyword For Auto Complete In Bulk Shopping Cart',
)

export const clearGlobalSearchKeywordForAutoComplete = createAction(
  '[ProductUI] Clear Global Sku Search Keyword For Auto Complete',
)

export const clearGlobalSkuSearchKeyword = createAction(
  '[ProductUI] Clear Global Sku Search Keyword'
)

export const setUISelectedPreferenceSKUId = createAction(
  '[ProductUI] Set UI Selected Preference SKU Id',
  props<{
    uiselectedPreferenceSKUId: number
  }>()
)

export const clearUISelectedPreferenceSKUId = createAction(
  '[ProductUI] Clear UI Selected Preference SKU Id'
)

export const setUICreateNewClassLoading = createAction(
  '[ProductUI] Set UI Create New Class Loading',
  props<{
    uicreateNewClassLoading: boolean
  }>()
)

export const clearUICreateNewClassLoading = createAction(
  '[ProductUI] Clear UI Create New Class Loading'
)

export const setSelectedProductInStockOnly = createAction(
  '[ProductUI] Set Selected Product In Stock Only',
  props<{
    uiselectedProductInStockOnly: boolean
  }>()
)

export const clearSelectedProductInStockOnly = createAction(
  '[ProductUI] Clear Selected Product In Stock Only',
)

export const setSelectedProductHalalOnly = createAction(
  '[ProductUI] Set Selected Product Halal Only',
  props<{
    uiselectedProductHalalOnly: boolean
  }>()
)

export const clearSelectedProductHalalOnly = createAction(
  '[ProductUI] Clear Selected Product Halal Only',
)

export const setCurrentPageNumberForProductList = createAction(
  '[ProductUI] Set current page number for product list',
  props<{
    uiCurrentPageNumberForProductList:number
  }>()
)

export const clearCurrentPageNumberForProductList = createAction(
  '[ProductUI] Clear current page number for product list'
)

export const setProductDetailTableLoading = createAction(
  '[ProductUI] Set Product Detail Table Loading',
  props<{
    uiProductDetailTableLoading: boolean
  }>()
)

export const clearProductDetailTableLoading= createAction(
  '[ProductUI] Clear Product Detail Table Loading'
)